import { styled } from '@mui/material';

export const StyledWrapper = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '8px 0',
    cursor: 'pointer',
  };
});
